// extracted by mini-css-extract-plugin
export default {"root":"placeholder_root__TKWrq"};